import { render, staticRenderFns } from "./EHistoricoFrequenciaTab.vue?vue&type=template&id=0a32552d&scoped=true"
import script from "./EHistoricoFrequenciaTab.vue?vue&type=script&lang=js"
export * from "./EHistoricoFrequenciaTab.vue?vue&type=script&lang=js"
import style0 from "./EHistoricoFrequenciaTab.vue?vue&type=style&index=0&id=0a32552d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32552d",
  null
  
)

export default component.exports